import { AppUserExtended } from "../../list-management/scripts/list-management.objects";

export class ViewDeliverablesModalConfig {
    modalIdTarget: string;
    getAttachmentsRoute: string;
    getCommentsRoute: string;
}

export class DeliverablesEditControllerConfig {
    submitRoute: string; // Route for submitting data on save
    modalIdTarget: string; // Modal id for the targeted popup
    isAdmin: boolean; // If this is for an admin (no readonly properties)
    isChild: boolean; // If this edit controller is for a child level element
    tableVarName: string; // variable name for the table
}

export class DeliverablesTableConfig {
    tableContainerId: string; // Where the table and filters will be placed on the page
    getDeliverablesRoute: string; // Route used for GET request for deliverables
    loadingContainerId: string // Id of the container showing loading indicator - show while loading
    loadedContentId: string // Id of the loaded content container - show after loading
    isEditable: boolean; // Allow items to be edited
    isAdmin: boolean; // If this is for an admin (no readonly properties)
    tableVarName: string; // name of the variable that is storing the DeliverablesTable item
    editModalId: string; // ID of the modal target for editing
    postParentRoute: string; // Route for posting parent saving
    postChildRoute: string; // Route for posting child saving
    commentModalId: string; // Modal Id to open for Comments
    getCommentsChildRoute: string; // Route for retrieving comments for child
    postCommentChildRoute: string; // Route for posting a new comment
    attachmentModalId: string; // Modal Id for edit attachements
    getAttachmentsRoute: string; // Route for getting existing attachments
    addAttachmentsRoute: string; // Route for adding attachments
    removeAttachmentsRoute: string; // Route for removing attachments
    addModalId: string; // ID of the modal target for adding
    additionalInfoModalId: string; // ID of modal containing additional information

    viewDeliverableModalId: string; // ID of the modal used for viewing deliverables;
    showUserGuide: boolean;
    userGuideLink: string;
}

export class DeliverablesCommentConfig {
    modalIdTarget: string; // Modal Id to open
    getCommentsChildRoute: string; // Route for retrieving comments for child
    postCommentChildRoute: string; // Route for posting a new comment
}

export class DeliverablesAttachmentsConfig {
    modalIdTarget: string; // Modal Id to open
    getAttachmentsRoute: string; // Route for retrieving existing attachments
    addAttachmentsRoute: string; // Route for adding attachments
    removeAttachmentsRoute: string; // Route for removing attachements
}

export class DeliverableOptGroupFilterItem {
    categoryId: number;
    itemId: number;
    constructor(categoryId: number, itemId: number) {
        this.categoryId = categoryId;
        this.itemId = itemId;
    }
}

export class DeliverableParentExtended {
    DeliverableParent: DeliverableParent = new DeliverableParent();
    DeliverableChildren: DeliverableChildExtended[] = [];
    SubcategoryIds: string = "";
    CoreIds: string = "";
    ProjectIds: string = "";
    VirusFamilyIds: string = "";
    StatusHistory: DeliverableStatusHistory[] = [];
    Comments: DeliverableComment[] = [];
    IsComplete: boolean = false;
    IsOngoing: boolean = false;
    ProjectYearIds: string = "";
    StatusId: number = 1;
    FurthestStageId: number = 0;
    LastUpdated: Date = new Date(1, 1, 1);
}

export class DeliverableChildExtended {
    DeliverableChild: DeliverableChild = new DeliverableChild();
    StatusHistory: DeliverableStatusHistory[] = [];
    ResponsibleAppUser: AppUserExtended = new AppUserExtended();
    Comments: DeliverableComment[] = [];
    IsComplete: boolean = false;
    IsOngoing: boolean = false;
    LastUpdated: Date = new Date(1, 1, 1);
    StatusId: number = 1;

    static createFromParent(parent: DeliverableParentExtended): DeliverableChildExtended {
        let child = new DeliverableChildExtended();
        child.DeliverableChild.CategoryId = parent.DeliverableParent.CategoryId;
        child.DeliverableChild.ParentId = parent.DeliverableParent.Id;

        return child;
    }
}

export class DeliverableParent {
    Id: number = 0;
    LastUpdated: Date = new Date(1, 1, 1);
    CenterId: number = 0;
    CategoryId: number = 0;
    Description: string = "";
    TrlTagId: number = 0;
    PrototypeVirusIds: string = "";
    TestVirusIds: string = "";
    TargetIds: string = "";
    PlannedStartDate: Date = new Date(1, 1, 1);
    PlannedEndDate: Date = new Date(1, 1, 1);
    ActualStartDate: Date = new Date(1, 1, 1);
    ActualEndDate: Date = new Date(1, 1, 1);
}

export class DeliverableChild {
    Id: number = 0;
    ParentId: number = 0;
    LastUpdated: Date = new Date(1, 1, 1);
    CenterId: number = 0;
    ProjectId: number = 0;
    CoreId: number = 0;
    CategoryId: number = 0;
    SubcategoryIds: string = "";
    StageId: number = 0;
    Description: string = "";
    ResponsiblePersonId: number = 0;
    HasAttachments: boolean = false;
}

export class DeliverableStatusHistory {
    Id: number = 0;
    Date: Date = new Date(1, 1, 1);
    ParentId: number = 0;
    ChildId: number = 0;
    CategoryId: number = 0;
    NewStatusId: number = 0;
    PreviousStatusId: number = 0;
    AppUserId: number = 0;
}

export class DeliverableComment {
    Id: number = 0;
    Date: Date = new Date(1, 1, 1);
    ParentId: number = 0;
    ChildId: number = 0;
    AppUserId: number = 0;
    Comment: string = "";
}
